import { EnergyInterfaceDetailsEditForm } from '../../components/energy-interface-details-edit-form/energy-interface-details-edit-form';
import { Component, computed, inject } from '@angular/core';
import { Alert, Button, ConfirmService, NotificationService, Skeleton } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { Router } from '@angular/router';
import { EnergyInterfacesStore } from '../../stores/energy-interfaces.store';
import { EnergyInterfaceDetailsPage } from '../energy-interface-details-page/energy-interface-details-page';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { EditFormSkeleton } from '../../../../shared/components/edit-form-skeleton/edit-form-skeleton';

@Component({
  selector: 'app-energy-interface-details-general-page',
  imports: [
    EnergyInterfaceDetailsEditForm,
    Button,
    NgIcon,
    Alert,
    TranslocoPipe,
    EditFormSkeleton,
    Skeleton,
  ],
  templateUrl: './energy-interface-details-general-page.html',
})
export class EnergyInterfaceDetailsGeneralPage {
  private router = inject(Router);
  private notificationService = inject(NotificationService);
  private confirmService = inject(ConfirmService);
  private energyInterfacesStore = inject(EnergyInterfacesStore);
  private translocoService = inject(TranslocoService);

  private detailsPage = inject(EnergyInterfaceDetailsPage);

  protected energyInterfaceId = this.detailsPage.energyInterfaceId;
  protected organizationId = this.detailsPage.organizationId;

  protected energyInterfaceState = computed(() =>
    this.energyInterfacesStore.energyInterfaces()?.find((ei) => ei.id === this.energyInterfaceId()),
  );

  protected isDeleteLoading = computed(() => this.energyInterfaceState()?.isDeleteLoading || false);

  protected async onClickDelete() {
    const confirm = await this.confirmService.confirm({
      title: this.translocoService.translate(
        'cockpit.energyInterfaces.details.general.deleteConfirmDialog.title',
      ),
      message: this.translocoService.translate(
        'cockpit.energyInterfaces.details.general.deleteConfirmDialog.message',
      ),
      mode: 'destructive',
      icon: 'heroTrash',
      confirmButtonText: this.translocoService.translate(
        'cockpit.energyInterfaces.details.general.deleteConfirmDialog.confirmButton',
      ),
      cancelButtonText: this.translocoService.translate(
        'cockpit.energyInterfaces.details.general.deleteConfirmDialog.cancelButton',
      ),
    });
    if (!confirm) {
      return;
    }
    try {
      await this.energyInterfacesStore.delete(this.energyInterfaceId());
      this.notificationService.showSuccess({
        title: this.translocoService.translate(
          'cockpit.energyInterfaces.details.general.deleteSuccess',
        ),
      });
      this.router.navigate(['/organizations', this.organizationId(), 'energy-interfaces'], {
        replaceUrl: true,
      });
    } catch (error) {
      console.error('Error deleting energy-interface:', error);
      this.notificationService.showError({
        title: this.translocoService.translate(
          'cockpit.energyInterfaces.details.general.deleteError',
        ),
      });
    }
  }
}
